import { CheckboxProps } from 'antd';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import useDidUpdate from '@/hooks/useDidUpdate';
import { CloseOutlined } from '@ant-design/icons';
import './index.less';

// interface ChecktagChangeEvent {
//   target: { checked: boolean };
// }

function Checktag({
  onChange,
  checked,
  disabled,
  defaultChecked,
  className,
  children,
  checktagtype,
  checktagcloseable,
}: CheckboxProps & { checktagtype?: 'tag'; checktagcloseable?: boolean }) {
  const [innerChecked, setInnerChecked] = useState(checked || defaultChecked);
  const adaptorOnChange = onChange || ((e: any) => setInnerChecked(e.checked));

  useEffect(() => {
    setInnerChecked(checked);
  }, [checked]);

  function innerOnchange() {
    // 这里的事件如何模拟？
    adaptorOnChange({ target: { checked: !innerChecked } } as any);
  }

  const classN = classnames(
    'acore-check-tag',
    className,
    { checked: innerChecked },
    { 'acore-check-tag-tag': checktagtype === 'tag' }
  );

  return (
    // 怎么模拟事件？？？
    <label onClick={innerOnchange} className={classN}>
      {children}
      {checktagcloseable && (
        <CloseOutlined
          style={{ verticalAlign: '.5px', marginLeft: '7px', fontSize: '10px' }}
          onClick={() => adaptorOnChange({ target: { checked: false } } as any)}
        />
      )}
    </label>
  );
}

// const Checktag = React.memo(InnerChecktag);

function ChecktagGroup(props: {
  children: React.ReactElement[];
  onChange?: (value: string[]) => void;
  value?: string[];
  defaultValue?: string[];
}) {
  const { children, onChange, value, defaultValue } = props;
  const [innerValue, setInnerValue] = useState(value || defaultValue || []);
  const adaptorOnChange = onChange || setInnerValue;

  useDidUpdate(() => {
    setInnerValue(value || []);
  }, [value]);

  return (
    <div className="acore-check-tag-group">
      {React.Children.map(children, (item) => {
        const checked = innerValue.includes(item.props.value);

        return React.cloneElement(item, {
          className: classnames('acore-check-tag-group-item', item.props.className),
          checked,
          // tofix: 这里需要优化
          onChange(ev: any) {
            if (ev.target.checked) adaptorOnChange([item.props.value, ...innerValue]);
            else adaptorOnChange(innerValue?.filter((valueItem) => item.props.value !== valueItem));
          },
        });
      })}
    </div>
  );
}

// question: 为啥扩展不上去
Checktag.ChecktagGroup = ChecktagGroup;

export default Checktag;
